
var id = "mima";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"mima\">\n<style type=\"text/css\">\n\t#mima .st0{fill:#1565C0;}\n</style>\n<path class=\"st0\" d=\"M156.6,85c8.5,0,15.4,6.7,15.4,15v70c0,8.3-6.9,15-15.4,15H43.4c-4.1,0-8-1.6-10.9-4.4\n\tc-2.9-2.8-4.5-6.6-4.5-10.6v-70c0-8.3,6.9-15,15.4-15L156.6,85 M156.6,70H43.4c-17.1,0-30.9,13.4-30.9,30v70c0,16.6,13.8,30,30.9,30\n\th113.2c17.1,0,30.9-13.4,30.9-30v-70C187.5,83.4,173.7,70,156.6,70L156.6,70z M100,15c9.5,0,18.7,3.7,25.5,10.2\n\tC132.2,31.7,136,40.7,136,50v20H64V50C64,30.7,80.1,15,100,15 M100,0C71.6,0,48.5,22.4,48.5,50v35h102.9V50\n\tc0-13.3-5.5-26.1-15.1-35.3C126.6,5.2,113.6,0,100,0z M100,157.5c-2,0-4-0.8-5.5-2.2c-1.4-1.4-2.3-3.3-2.2-5.3v-30\n\tc0-4.1,3.4-7.5,7.7-7.5c4.2,0,7.7,3.4,7.7,7.5v30C107.7,154.2,104.2,157.5,100,157.5L100,157.5z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
